<div class="drtv_stats__flex">
  <img [src]="icon" alt="" loading="lazy" width="100" class="stat-icon">
  <p class="percentage">{{ percentage }}%</p>
  <p [style.color]="icon"><ng-content></ng-content></p>
</div>
